import { Workflow } from 'pages/AgenticWorkflow/AgenticWorkflow.types';
import axiosInstance from './config/api';

export const getAgenticWorkflows = () => {
    return axiosInstance.get<Workflow[]>('/workflows').then((res) => res.data);
};
